import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import GTRModal from './GTRModal';
import BillDetail from './BillDetail';

class OrderDetailModal extends Component {
  render() {
    const { history } = this.props;
    return (
      <GTRModal history={history} title={"Bill Detail"}>
        <BillDetail {...this.props} />
      </GTRModal>
    );
  }
}

export default OrderDetailModal;